// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-container[data-v-2843a0da]{padding:30px 0;display:block;height:60px;line-height:60px;text-align:center;font-size:40px;letter-spacing:.2em}", ""]);
// Exports
module.exports = exports;
